import styled from 'styled-components';
import {
    infoColor,
    grayColor,
  } from "~/components/layout/Variables";

export const ContainerCard = styled.div`
  margin-top: 0rem;
`;

export const TitlePage = styled.h1`
  color: white;
  font-size: 1.3rem;
  text-align: center;
  padding-top: 2rem;
  font-weight: 200;
  margin-bottom: -0.7rem;
  display: flex;
  justify-content: space-between;

  @media (min-width: 770px) {
    margin: 0 auto 0 auto;
    max-width: 762px;
  }

  img {
    @media (max-width: 770px) {
      margin: 0 1rem 1rem -3rem;
    }
  }
`;

export const CloseIconStyled = styled.img`
  width: 10%;
  height: 10%;
  position: relative;
  cursor: pointer;

  @media (min-width: 420px) {
    width: 8%;
    height: 8%;
  }

  @media (min-width: 500px) {
    width: 6%;
    height: 6%;
  }

  @media (min-width: 1000px) {
    width: 28px;
    height: 28px;
    margin-top: 19px;
  }

  @media (max-width: 770px) {
    margin-left: 0.5rem;
  }
`;

export const PrintIconStyled = styled.img`
  width: 10%;
  height: 10%;
  position: relative;
  cursor: pointer;

  @media (min-width: 420px) {
    width: 8%;
    height: 8%;
  }

  @media (min-width: 500px) {
    width: 6%;
    height: 6%;
  }

  @media (min-width: 1000px) {
    width: 6%;
    height: 6%;
  }
`;

export const Title = styled.h2`
  font-size: 1.1rem;
  font-weight: bold;
  color: ${() => grayColor};
  display: flex;
  justify-content: space-between;

  @media(min-width: 768px) {
    font-size: 1.2rem;
    margin: 1rem 0 0 0;
    display: flex;
    align-items: center;
  }
`;

export const AccordionDivision = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const Product = styled.span`
  font-size: 1.1rem;
  color: ${() => infoColor};
  display: flex;
  justify-content: left;
`;

export const SubTitle = styled.p`
  font-size: 1.1rem;
  color: ${() => grayColor};
  margin: 1rem 0.5rem 1.5rem 0rem;

  @media(min-width: 770px) {
    margin: .5rem 0.5rem .5rem 0rem;
  }
`;

export const Quantity = styled.span`
  font-size: 1.1rem;
  color: ${() => grayColor};
  margin-right: 0.5rem;
`;

export const ValueQuantity = styled(SubTitle)`
  text-align: right;
  font-weight: bold;

  @media (max-width: 700px) {
    text-align: center;
  }
`;

export const LeftItemQuantity = styled(SubTitle)`
  width: 100%;
  text-align: left;
  font-weight: bold;

  @media (max-width: 700px) {
    text-align: center;
  }
  @media (max-width: 400px) {
    font-size: 0.75rem;
  }
  @media (max-width: 310px) {
    font-size: 0.65rem;
  }
`;

export const LeftItemQuantityTotal = styled(SubTitle)`
  width: 100%;
  text-align: left;
  font-weight: bold;
  color: #fff;

  @media (max-width: 700px) {
    text-align: center;
  }
  @media (max-width: 400px) {
    font-size: 0.75rem;
  }
  @media (max-width: 310px) {
    font-size: 0.65rem;
  }
`;

export const CenterItemQuantity = styled(SubTitle)`
  width: 100%;
  text-align: center;

  @media (max-width: 700px) {
    text-align: center;
  }
  @media (max-width: 400px) {
    font-size: 0.75rem;
  }
  @media (max-width: 310px) {
    font-size: 0.65rem;
  }
`;

export const RightItemQuantity = styled(SubTitle)`
  width: 100%;
  text-align: right;

  @media (max-width: 700px) {
    text-align: right;
  }
  @media (max-width: 400px) {
    font-size: 0.75rem;
  }
  @media (max-width: 310px) {
    font-size: 0.65rem;
  }
`;

export const RightItemQuantityTotal = styled(SubTitle)`
  width: 100%;
  text-align: right;
  color: #fff;

  @media (max-width: 700px) {
    text-align: right;
  }
  @media (max-width: 400px) {
    font-size: 0.75rem;
  }
  @media (max-width: 310px) {
    font-size: 0.65rem;
  }
`;

export const SubRightItemQuantity = styled(SubTitle)`
  width: 100%;
  text-align: right;
  font-size: 0.75rem;
  margin-top: 1rem;

  @media (max-width: 700px) {
    text-align: right;
  }
  @media (max-width: 400px) {
    font-size: 0.65rem;
  }
  @media (max-width: 310px) {
    font-size: 0.55rem;
  }
`;

export const SubLeftItemQuantity = styled(SubTitle)`
  width: 100%;
  text-align: left;
  font-size: 0.75rem;

  @media (max-width: 700px) {
    text-align: center;
  }
  @media (max-width: 400px) {
    font-size: 0.65rem;
  }
  @media (max-width: 310px) {
    font-size: 0.55rem;
  }
`;

export const SubCenterItemQuantity = styled(SubTitle)`
  width: 100%;
  text-align: center;
  font-size: 0.75rem;
  margin-top: 1rem;

  @media (max-width: 700px) {
    text-align: center;
  }
  @media (max-width: 400px) {
    font-size: 0.65rem;
  }
  @media (max-width: 310px) {
    font-size: 0.55rem;
  }
`;

export const LeftHeaderQuantity = styled(SubTitle)`
  width: 100%;
  text-align: left;
  font-weight: bold;

  @media (max-width: 700px) {
    text-align: center;
  }
  @media (max-width: 500px) {
    font-size: 0.75rem;
  }
  @media (max-width: 450px) {
    font-size: 0.65rem;
  }
`;

export const LefItemQuantity = styled(SubTitle)`
  width: 100%;
  text-align: left;
  margin-top: 1rem;

  @media (max-width: 700px) {
    text-align: center;
  }
  @media (max-width: 500px) {
    font-size: 0.75rem;
  }
  @media (max-width: 450px) {
    font-size: 0.65rem;
  }
`;

export const CenterHeaderQuantity = styled(SubTitle)`
  width: 100%;
  text-align: center;
  padding-top: 0.1rem;

  @media (max-width: 700px) {
    text-align: center;
  }
  @media (max-width: 500px) {
    font-size: 0.75rem;
  }
  @media (max-width: 450px) {
    font-size: 0.65rem;
  }
`;

export const RightHeaderQuantity = styled(SubTitle)`
  width: 100%;
  text-align: right;

  @media (max-width: 700px) {
    width: 80%;
  }
  @media (max-width: 500px) {
    width: 60%;
  }
  @media (max-width: 310px) {
    width: 50%;
  }
`;

export const ColAppliedHeaderQuantity = styled.div`
  text-align: center;
  margin: 1rem 0.5rem 1.5rem 0rem;

  @media(min-width: 770px) {
    margin: .5rem 0.5rem .5rem 0rem;
  }
`;

export const SelectProduct = styled.button`
  width: ${(props) => (props.width ? props.width : `100%`)};
  font-size: 1.2rem;
  color: #949494;
  border: 0.6px solid rgba(80, 80, 80, 0.3);
  background-color: #fff;
  box-shadow: 0px 2px 2px #00000029;
  border-radius: 0.4rem;
  padding: 0.2rem 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: ${(props) => props.margin};

  span {
    color: #000FFF;
  }
`;

export const ItemDivision = styled.div`
  margin: 1.5rem 0;
  box-shadow: 0px 2px 4px #00000033;
  border-radius: .5rem;
`;

export const BackIcon = styled.span`
  display: flex;
  justify-content: flex-end;
  margin: 1rem 1rem 0 0;
  cursor: pointer;
`;

export const LoadingContainer = styled.div`
  width: 20%;
  margin: 70% auto;
`

export const AlignProducts = styled.div`
  display: grid;
  grid-template-columns: 15% 65% 20%;
  width: 100%;

  .product {
    margin: .5rem .5rem;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .align-icon {
    margin: .5rem;
  }
`;

export const AlignDropdownBranch = {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between"
  };

export const ButtonDivision = styled.div`
  width: 50%;
  margin: 1rem auto 3.5rem auto;

  @media(max-width: 600px) {
    width: 100%;
  }
`;

export const LoadingIcon = styled.i`
  font-size: 18px;
`;

export const CardInput = styled.div`
  margin-top: 3rem;
`;

export const CardInputItem = styled.div`
  margin-top: 1rem;
`;

export const CardBodyItem= styled.div`
  margin: 0 1rem;
`;

export const CardHeader = {
  backgroundColor: "rgb(230, 223, 223)",
  color: "rgb(112, 112, 112)",
  fontSize: ".9rem",
  fontWeight: "550",
  padding: ".2rem 1rem",
  borderRadius: "0.3rem",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
};

export const CardHeaderTotal = {
  backgroundColor: "#777",
  color: "#fff",
  fontSize: ".9rem",
  fontWeight: "550",
  padding: ".2rem 1rem",
  borderRadius: "0.3rem",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
};

export const InputApproved = styled.input`
  font-size: 1.5rem;
  text-align: center;
  background-color: #fff;
  border: 1px solid #b0b0b0;
  border-radius: 0.3rem;
  width: 100%;
`;

export const InputApply = styled.input`
  font-size: 1.5rem;
  text-align: center;
  background-color: #fff;
  border: 1px solid #b0b0b0;
  border-radius: 0.3rem;
  width: 100%;
`;

export const CardBody = styled.div`
  font-weight: 500;
  background-color: #fff;
  display: flex;
  flex-wrap: wrap;
  margin-right: -15px;
  margin-left: -15px;
  margin-bottom: 0.5rem;
  padding: 1rem;
  border-radius: 1rem;
`;

export const HeaderMessage = styled.p`
  width: 100%;
  margin-top: ${(props) => props.isMobile && "1.5rem" };
  margin-bottom: ${(props) => props.isMobile && "2rem" };
  margin-left: .5rem;
  text-align: left;
  color: #707070;
  font-size: ${(props) => props.isMobile && "14px" };
`;

export const HeaderAccountMessage = styled.div`
  margin-left: .5rem;
  text-align: left;
  color: #707070;
  font-size: ${(props) => props.isMobile && "14px" };
  margin-bottom: ${(props) => props.last ? "0.7rem" : "0"};
`;

export const ContainerBillet = styled.div`
  width: 100%;
  height: 100%;
  background-color: #ffffff;
`;

export const HeaderIcon = styled.i`
  font-size: 29px;
  color: #ffffff;
`;

export const HeaderText = styled.span`
  font-size: 15px;
  color: #ffffff;
`;

export const CloseIconContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  padding: 0px 20px;
`;

export const CloseIcon = styled.div`
  font-size: 28px;
  color: #808080;
  cursor: pointer;
`;

export const PageTitleContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-top: 3rem;
  //padding: 0px 20px;
`;

export const PageIcon = styled.i`
  font-size: 40px;
  color: #808080;
`;

export const PageTitle = styled.span`
  color: #808080;
  font-size: 20px;
  font-weight: 300;
`;

export const PageContent = styled.span`
  color: #808080;
  font-size: 20px;
  font-weight: 300;
`;

export const BankSlipsContainer = styled.div`
  width: 100%;
  //padding: 20px;
`;

export const DesktopWrapper = styled.div`
  width: 100vw;
  display: none;

  @media (min-width: 1000px) {
    display: initial;
  }
`;

export const MobileWrapper = styled.div`
  width: 100vw;
  display: none;

  @media (max-width: 1000px) {
    display: initial;
  }
`;

export const Content = styled.div`
  height: 95%;
  width: 100%;
  padding: 0 100px;

  @media (max-width: 1360px) {
    padding: 0 50px;
  }

  @media (max-width: 1220px) {
    padding: 0;
  }

  @media (max-width: 768px) {
    height: 100vh;
    width: 100%;
  }
`;

export const NextPage = styled.span`
  color: #000FFF;
  padding: 0.5rem;
  border-radius: 0.5rem;
  cursor: pointer;
`;

export const NextPageContainer = styled.div`
  display: flex;
  justify-content: ${(props) => props.content};
  margin-bottom: 1.5rem;
  color: #000FFF;
`;

export const PageTitleItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const FilterWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
`;

export const FilterText = styled.span`
  color: #000FFF;
  font-size: 14px;
`;

export const FilterIcon = styled.img`
  width: 15px;
  height: auto;
  margin-right: 5px;
`;

export const DesktopHeaderContainer = styled.div`
  width: 100%;
  padding: 0 0 20px 20px;
  background-color: white;
  margin-bottom: 30px;
  @media (max-width: 770px) {
    padding: 0;
  }
`;

export const WrapperBankslips = styled.div`
  height: 89%;
  width: 100%;
  margin-top: 5rem;
  margin-bottom: 5rem;
  overflow-y: scroll;

  @media (max-width: 770px) {
    margin-top: 0px;
  }
`;

export const PageContainer = styled.div`
  height: 100vh;
  width: 100vw;
  padding: 0px;
  margin: 0px;
  background-color: #ffffff;
  overflow-y: none;
`;

export const HeaderMobile = styled.div`
  width: 100%;
  height: auto;
  display: none;
  align-items: center;
  justify-content: center;
  background-color: #000FFF;
  color: #ffffff;
  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.1);
  padding: 5px;
  margin-bottom: 20px;

  @media (max-width: 768px) {
    display: flex;
  }
`;

export const MessageNothing = styled.p`
  text-align: center;
  margin: 2rem;
  font-size: 1.2rem;
  color: #808080;

  @media (max-width: 768px) {
    margin: 1rem;
    font-size: 1rem;
  }
`;

export const BankslipMessage = styled.div`
  display: flex;
  justify-content: center;
  margin: 1rem 0 0 0;

  span {
    color: #808080;
  }
`;
